import { createSelector } from 'reselect'

import { getDefaultRedirectUrl } from 'models/location/selectors'

const getUser = (state) => state.user

export const getIsLoggedIn = (state) => state.user.isLoggedIn
export const getUserId = (state) => state.user.wid
export const getUserEmail = (state) => state.user.email
export const getIsNewUser = (state) => state.user.isNewUser
export const getIsAdmin = (state) => state.user.isAdmin
export const getCanBeAdmin = (state) => state.user.canBeAdmin
export const getFirstName = (state) => state.user.firstName
export const getLastName = (state) => state.user.LastName
export const getRedirectUrl = (state) => state.user.redirectUrl || `${getDefaultRedirectUrl()}dashboard`
export const getPasswordResetStatus = (state) => state.user.passwordResetStatus
export const getChangePasswordStatus = (state) => state.user.changePasswordStatus
export const getTriggerPasswordResetStatus = (state) => state.user.triggerPasswordResetStatus
export const getEarlyAccessSubscribeStatus = (state) => state.user.earlyAccessSubscribeStatus
export const getSubCatalogs = (state) => state.user.subCatalogs
export const getHasSeenMagicEraserTutorial = (state) => state.user.hasSeenMagicEraserTutorial
export const getAppDownloadSmsStatus = (state) => state.user.appDownloadSmsStatus

export const getName = createSelector([getFirstName, getLastName], (fn, ln) => (fn && ln ? `${fn} ${ln}` : ''))

export const getCurrentUser = createSelector([getUser, getName, getRedirectUrl], (user, name, redirectUrl) => ({
    ...user,
    name,
    redirectUrl,
}))
